import {select, fork, take, put} from 'redux-saga/effects';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as sasdActionTypes from '../sasdActionTypes';

/**
 * Search relevant location geolocation
 */
const searchSASDRelevantLocationGeolocation = function* searchSASDRelevantLocationGeolocation({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    const {searchQueryString, serviceAssignmentId} = payload;
    yield fork(
        fetchRequest,
        sasdActionTypes.SEARCH_SASD_RELEVANT_LOCATION_GEOLOCATION_REQUEST,
        arcGISRESTService.searchAddressSuggestions,
        {singleLine: searchQueryString, outFields: ['StAddr', 'Postal', 'City', 'Country', 'Region']},
    );

    const searchRelevantLocationGeolocation = yield take([
        sasdActionTypes.SEARCH_SASD_RELEVANT_LOCATION_GEOLOCATION_REQUEST_SUCCEEDED,
        sasdActionTypes.SEARCH_SASD_RELEVANT_LOCATION_GEOLOCATION_REQUEST_FAILED,
    ]);

    if (!searchRelevantLocationGeolocation.error) {
        const {response} = searchRelevantLocationGeolocation.payload;
        const {arcGISLocationCandidateDTOs} = response;

        yield put({
            type: sasdActionTypes.SET_SASD_RELEVANT_LOCATION_CANDIDATES,
            payload: {
                locationKey: 'relevantLocation',
                arcGISLocationCandidateDTOs,
                serviceAssignmentId,
                searchQueryString,
            },
        });
    }
};

export default searchSASDRelevantLocationGeolocation;
